export function easeInOutCubic(t: number): number {
  if (t < 0.5) {
    return 4 * t * t * t;
  } else {
    const f = 2 * t - 2;
    return 0.5 * f * f * f + 1;
  }
}

export function easeInExp(t: number): number {
  return Math.pow(2, 10 * (t - 1));
}

export function easeInCubic(t: number): number {
  return t * t * t;
}

export function easeOutCubic(t: number): number {
  const f = t - 1;
  return f * f * f + 1;
}

export function linear(t: number): number {
  return t;
}

export function easeInSine(t: number): number {
  return 1 - Math.cos((t * Math.PI) / 2);
}

export function easeOutBack(x: number): number {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
}

export type InterpolationFunction = (a: number, b: number, t: number) => number;
export type EaseFunction = (t: number) => number;

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function lerpEased(
  a: number,
  b: number,
  t: number,
  ease: EaseFunction,
): number {
  return lerp(a, b, ease(t));
}
